import { render, staticRenderFns } from "./PrintBillK80.vue?vue&type=template&id=58f0d1ea&scoped=true"
import script from "./PrintBillK80.vue?vue&type=script&lang=js"
export * from "./PrintBillK80.vue?vue&type=script&lang=js"
import style0 from "./PrintBillK80.vue?vue&type=style&index=0&id=58f0d1ea&prod&lang=css&scoped=true"
import style1 from "./PrintBillK80.vue?vue&type=style&index=1&id=58f0d1ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f0d1ea",
  null
  
)

export default component.exports